import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles'
import { Box, Button, Grid, Snackbar  } from '@material-ui/core';
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux';

import MenuDialog from './MenuDialog' // メニュー
import PropertyListDialog from './PropertyListDialog' // 財産リスト
import PeopleListDialog from './PeopleListDialog' // 人リスト

const useStyles = makeStyles((theme) => ({
    menu: {
        marginTop: '1rem',
    },
}));

function PropertyMenu(props) {
    const history = useHistory();

    const [open, setOpen] = useState(false);

    const [openProperty, setOpenProperty] = useState(false);

    const [alert, setAlert] = useState(false);

    const igonFlag = useSelector(state => state.igon.igonFlag);

    const registData = () => {
        props.execute();
        setAlert(true);
    }

    const alertClose = () => {
        setAlert(false);
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        // props.execute();
    }

    const handleAuthor = () => {
        if(igonFlag){
            history.push('/authorwill');
        }else{
            history.push('/author');
        }
    }

    const handleTestament = () => {
        history.push('/testament');
    }

    const handleHeiress = () => {
        history.push('/heiress');
    }

    const handlePropertyListOpen = () => {
        setOpenProperty(true);
    }

    const handlePropertyListClose = () => {
        setOpenProperty(false);
    }

    const state = useSelector(state => state);

    const handleCreateZaisan = () => {
        const zaisanState = { ...state };
        zaisanState.testament = null;
        zaisanState.heiress = null;

fetch('https://igon-sozoku.jp/will/create_pdf.php', {
//fetch('http://192.168.33.10/igon-sozoku/create_pdf.php', {
            'method': 'POST',
            'body': JSON.stringify(zaisanState),
        }).then(response => {
            if(response.ok){
                return response.text();
            }else{
                return Promise.reject(new Error('システムエラー'));
            }
        }).then(text => {
            window.open(text, '_blank');
        }).catch(e => {
            console.log(e.message);
        });
    }

    const handleCreateJihituAndZaisan = () => {
fetch('https://igon-sozoku.jp/will/create_pdf.php', {
//fetch('http://192.168.33.10/igon-sozoku/create_pdf.php', {
            'method': 'POST',
            'body': JSON.stringify(state),
        }).then(response => {
            if(response.ok){
                return response.text();
            }else{
                return Promise.reject(new Error('システムエラー'));
            }
        }).then(text => {
            window.open(text, '_blank');
        }).catch(e => {
            console.log(e.message);
        });
    }

    const classes = useStyles();

    return(
        <Box>
            <Box className={classes.menu}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Button variant="contained" color="secondary" fullWidth onClick={registData}>入力した財産を登録する</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained" color="default" fullWidth onClick={() => { history.goBack(); }}>前のページへ戻る</Button>
                    </Grid>
                </Grid>
            </Box>
            <Box className={classes.menu}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Button variant="contained" color="primary" fullWidth onClick={handleOpen}>メニューから保有する財産を選ぶ</Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button variant="contained" color="primary" fullWidth onClick={handlePropertyListOpen}>入力した財産の一覧</Button>
                    </Grid>

                    <MenuDialog open={open} onClose={handleClose}/>
                    <PropertyListDialog open={openProperty} onClose={handlePropertyListClose}/>
                </Grid>
            </Box>
            <Box className={classes.menu}>
                <Grid container spacing={2}>
                    {
                        (() => {
                            if(igonFlag){
                                return(
                                    <>
                                        <Grid item xs={4}>
                                            <Button variant="contained" color="primary" fullWidth onClick={handleAuthor}>作成者情報を編集する</Button>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Button variant="contained" color="primary" fullWidth onClick={handleTestament}>遺言者を編集する</Button>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Button variant="contained" color="primary" fullWidth onClick={handleHeiress}>相続人を編集する</Button>
                                        </Grid>
                                    </>
                                );
                            }else{
                                return(
                                    <Grid item xs={12}>
                                        <Button variant="contained" color="primary" fullWidth onClick={handleAuthor}>作成者情報を編集する</Button>
                                    </Grid>
                                );
                            }
                        })()
                    }
                </Grid>
            </Box>
            <Box className={classes.menu}>
                <Grid container spacing={2}>
                    {
                        (() => {
                            if(igonFlag){
                                return(
                                    <Grid item xs={12}>
                                        <Button variant="contained" color="primary" fullWidth onClick={handleCreateJihituAndZaisan}>完了して財産目録と自筆遺言書を作成する</Button>
                                    </Grid>
                                );
                            }else{
                                return(
                                    <Grid item xs={12}>
                                        <Button variant="contained" color="primary" fullWidth onClick={handleCreateZaisan}>完了して財産目録を作成する</Button>
                                    </Grid>
                                );
                            }
                        })()
                    }
                </Grid>
            </Box>

            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={alert} autoHideDuration={3000} onClose={alertClose} message={props.message}/>
        </Box>
    );
}

export default PropertyMenu;
